<img class="logo h-28 um-desktop:mb-0 um-desktop:logo-margins"
  [ngClass]="'czarno-biale-logo'"
  [matTooltip]="toolTip"
  [alt]="alt"
  [attr.aria-label]="ariaLabel" (keyup.enter)="klikEnter()" (click)="klikEnter()"
  [width]="partner.szerokosc ? partner.szerokosc : 90" [src]="src" />
